<template>
  <div class="orderNotice">
    <h2>北京理工大学校园文明行为促进公约</h2>
    <p><b>一、爱护环境卫生。</b>不随地吐痰、便溺；不乱丢垃圾，按规分类；不在非吸烟场所吸烟；不乱写乱画、乱贴宣传品。</p>
    <p><b>二、维护公共秩序。</b>按规定进出校园；不高空抛物；不噪声干扰教学办公环境，不扰乱校园活动秩序；不施放“低慢小”航空器、风筝、气球、孔明灯；不私自举办展览、摆摊经营；不私自组织参观、游学团队；不在校园内遛狗；爱护动物、花草树木及公共设施，不攀爬、不损坏。</p>
    <p><b>三、规范文明出行</b>。遵守交通法规，礼让行人，有序停放；不超速行驶、不乱停乱放；不私设阻碍物、不擅自封路等妨碍机动车停放或通行。</p>
    <p><b>四、关注消防安全</b>。不在公共区域堆放杂物；不私拉乱接电线，规范电动车充电；爱护消防设施；不违规动火作业；不堵塞消防通道。</p>
    <p><b>五、共筑网络文明。</b>依法自律上网，自觉抵御不良有害信息，不信谣传谣，不跟风炒作，不恶意谩骂、诋毁、诽谤他人，不传播未经证实有可能造成负面影响的信息；不随意打开不明网站，不轻易透漏个人和他人重要信息。</p>
   
    
    <div class="btns" v-if="$route.query.btn == 1">
      <van-button round type="primary"  @click="$router.replace({path: 'orderadd'})">同意，我要预约</van-button>
      <van-button round type="danger" @click="$router.go(-1)">离开</van-button>
    </div>
    
    
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="less">
  .orderNotice {
    height: 100vh;
    padding: 8px;
    overflow-y: auto;
    h2 {
      font-size: 5vmin;
      text-align: center;
      margin: 20px 0;
    }
    p {
      font-size: 16px;
      // 首行缩进
      text-indent: 16px;
      // 行间距
      line-height: 24px;
      margin-bottom: 10px;
      padding: 0 4px
    }
    b {
      color: red;
    }
  }
  .btns {
    display: flex;
    justify-content: space-around;
    margin: 20px 0;
    .van-button {
      width: 40%;
    }
  }
</style>